:host {
    display: block;
    border: 1px solid $color-grey-04-middle;
    background-color: $color-grey-06-bright;
    position: relative;
}

.link {
    all: unset;
    cursor: pointer;
}

.icon {
    position: absolute;
    top: 0;
    right: 0;
    background-color: $color-red;
    color: $color-white;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
}

.image-wrapper {
    position: relative;
    aspect-ratio: 2/1;
}

.content {
    padding: 16px 32px 24px;
    display: flex;
    flex-direction: column;
}

.date {
    @include typo-ws-paragraph;

    color: $color-grey-03;
}

.headline {
    @include typo-ws-h4;

    margin: 8px 0 32px;
    display: flex;
    align-items: center;
    column-gap: 3px;
    transform: translateX(-21px);
    transition:
        transform 0.2s,
        color 0.2s;

    .svg {
        flex-shrink: 0;
        opacity: 0;
        transition: opacity 0.2s;
    }
}

.tags {
    display: flex;
    flex-wrap: wrap;
    column-gap: 8px;
    row-gap: 8px;
    margin-top: auto;
}

.tag {
    @include typo-ws-paragraph-s;

    line-height: 24px;
    padding: 0 8px;
    border-radius: 8px;
    border: 1px solid $color-grey-04-middle;
    color: $color-grey-03;
}

:host(:hover) {
    .headline {
        color: $color-red;
        transform: translateX(0);

        .svg {
            opacity: 1;
        }
    }
}
